// Original animated SVG hero illustration — a yellow "hub" node
// connected to six gray nodes via dashed, flowing lines. Stands in
// for photography/video, which doesn't exist yet for the company.
const HeroVisual = () => {
  const hub = { x: 160, y: 140 };
  const nodes = [
    { x: 40, y: 50 }, { x: 160, y: 24 }, { x: 280, y: 50 },
    { x: 40, y: 230 }, { x: 160, y: 256 }, { x: 280, y: 230 },
  ];
  return (
    <svg viewBox="0 0 320 280" width="100%" height="auto" role="img" aria-label="Illustration of a central hub connected to a network of six devices">
      {nodes.map((n, i) => (
        <line key={i} x1={hub.x} y1={hub.y} x2={n.x} y2={n.y} stroke="var(--dw-line)" strokeWidth="1.5" className="dw-flow-line" />
      ))}
      {nodes.map((n, i) => (
        <circle key={i} cx={n.x} cy={n.y} r="7" fill="var(--dw-panel-2)" stroke="var(--dw-text-faint)" strokeWidth="1.5" />
      ))}
      <circle cx={hub.x} cy={hub.y} r="9" fill="var(--dw-accent)" className="dw-hub" />
    </svg>
  );
};

export default HeroVisual;
